jQuery(document).ready(function ($) {
    $('#invoice-form').submit(function (e) {
        e.preventDefault();
        var formData = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: journalAjax.ajaxurl,
            data: {
                action: 'pen_invoice_retrieve',
                form_data: formData
            },
            success: function (response) {
                $('.invoice-content').html(response);
            },
            error: function (xhr, status, error) {
                console.log(xhr.responseText);
            }
        });
    });
});